import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-area-header',
    templateUrl: './area-header.component.html',
    styleUrls: ['./area-header.component.scss'],
    standalone: false,
})
export class AreaHeaderComponent {
    @Input() profilePicture: string;
    @Input() largeHeadline: string;
    @Input() smallHeadlineTranslationKey: string;
    @Input() smallHeadlineRaw: string;
    @Input() smallHeadlineIconPath: string;
    @Input() buttonTextTranslationKey: string = undefined;
    @Input() round: boolean = true;
    @Input() enablePictureUpload: boolean = false;

    @Output() buttonClicked: EventEmitter<void> = new EventEmitter<void>();
    @Output() pictureSelected: EventEmitter<File> = new EventEmitter<File>();

    constructor() {}

    onButtonClick(): void {
        this.buttonClicked.emit();
    }

    onFileSelected(event: Event): void {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files.length > 0) {
            this.pictureSelected.emit(input.files[0]);
            input.value = ''; // Reset to allow selecting the same file again
        }
    }

    onCameraOverlayKeyUp(
        event: KeyboardEvent,
        fileInput: HTMLInputElement
    ): void {
        const key = event.key;
        if (key === 'Enter' || key === ' ') {
            event.preventDefault();
            fileInput.click();
        }
    }
}
